/**
 * Input validation and field limit constants
 */

// Field length limits
export const NUMERIC_FIELD_LIMIT: number = 10;
export const VENDOR_NAME_FIELD_LIMIT: number = 35;
export const ITEM_DESCRIPTION_FIELD_LIMIT: number = 58;

// Form validation patterns (if needed in the future)
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const PHONE_REGEX = /^\+?[\d\s\-\(\)]+$/;
